export default __webpack_public_path__ + "static/media/close-btn.e6026679.svg";